import React from 'react'
import {Button, Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {PAYMENT_COLORS} from './constants'

export default function GatewayActions({
  connected,
  onConnect,
  onManage,
  onDelete,
  busy,
}: {
  connected: boolean
  onConnect: () => void
  onManage: () => void
  onDelete: () => void
  busy?: boolean
}) {
  const {t} = useTranslation()

  if (!connected) {
    return (
      <Button
        fullWidth
        disabled={busy}
        onClick={onConnect}
        sx={{
          height: 40,
          fontWeight: 600,
          fontSize: 14,
          textTransform: 'none',
          backgroundColor: PAYMENT_COLORS.primary,
          color: '#fff',
          '&:hover': {backgroundColor: '#244A96'},
        }}
      >
        {t('payment.buttons.connect') as string}
      </Button>
    )
  }

  return (
    <Stack direction='row' gap={1}>
      <Button
        fullWidth
        disabled={busy}
        variant='outlined'
        onClick={onManage}
        sx={{
          height: 40,
          fontWeight: 600,
          fontSize: 14,
          textTransform: 'none',
          borderColor: PAYMENT_COLORS.border,
          color: PAYMENT_COLORS.textPrimary,
        }}
      >
        {t('payment.buttons.manage') as string}
      </Button>
      <Button
        disabled={busy}
        onClick={onDelete}
        sx={{
          height: 40,
          minWidth: 96,
          fontWeight: 600,
          fontSize: 14,
          textTransform: 'none',
          backgroundColor: 'rgba(239,68,68,0.08)',
          color: PAYMENT_COLORS.error,
          '&:hover': {backgroundColor: 'rgba(239,68,68,0.16)'},
        }}
      >
        {t('payment.buttons.delete') as string}
      </Button>
    </Stack>
  )
}
